import { styled } from '@mui/material'

export const Root = styled('div')`
  padding: 10px 46px;
  ${props => props.theme.breakpoints.down('md')} {
    padding: ${props => props.padding || '10px 18px'};
  }
`

export const Navigation = styled('section')`
  width: 100%;
`
